module.exports = __webpack_public_path__ + "img/data-item5-3.fe27e47.png";